import classNames from 'classnames/bind';

import { SearchConditionIcon } from 'asset/svg';
import { useDeletePriceChangesSubscription } from 'hooks/usePriceChangesSubscriptions';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface Props {
  isSubscribed: boolean;
  searchKey: string;
  onCompleted?(): void;
}

export default function SubscriptionStatus({
  isSubscribed,
  searchKey,
  onCompleted,
}: Props) {
  const deleteSubscription = useDeletePriceChangesSubscription(searchKey);

  function onDelete() {
    if (window.confirm('선택하신 가격 알림을 삭제하시겠습니까?')) {
      deleteSubscription({ onCompleted });
    }
  }

  return (
    <b
      className={cx('noti')}
      aria-checked={isSubscribed}
      tabIndex={isSubscribed ? 0 : undefined}
      onClick={isSubscribed ? onDelete : undefined}
    >
      <SearchConditionIcon className={cx('icon')} />
      {isSubscribed ? '알림받는중' : '알림받기'}
    </b>
  );
}
